var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCalendarHeart = function SvgCalendarHeart(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14.8571 14.8571",
    width: "100%",
    height: "100%",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar-heart--calendar-date-day-favorite-heart-like-month"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57143 1.14286C4.57143 0.511674 4.05975 0 3.42857 0C2.79739 0 2.28571 0.511674 2.28571 1.14286V2.28571H1.71429C0.767509 2.28571 0 3.05322 0 4V13.1429C0 14.0896 0.767509 14.8571 1.71429 14.8571H13.1429C14.0896 14.8571 14.8571 14.0896 14.8571 13.1429V4C14.8571 3.05322 14.0896 2.28571 13.1429 2.28571H12.5714V1.14286C12.5714 0.511674 12.0598 0 11.4286 0C10.7974 0 10.2857 0.511674 10.2857 1.14286V2.28571H4.57143V1.14286ZM7.43009 6.23305C6.86986 5.80458 6.29831 5.58847 5.74345 5.57745C5.05299 5.56375 4.47201 5.87014 4.0709 6.3176C3.30245 7.17486 3.10992 8.68314 4.12822 9.65714L4.13014 9.65897L6.37045 11.7819C6.96649 12.3467 7.89354 12.3467 8.4896 11.7819L10.7299 9.65897L10.7318 9.65714C11.7488 8.68441 11.5535 7.17696 10.7859 6.3207C10.3851 5.87355 9.80466 5.56677 9.11473 5.57976C8.56039 5.59021 7.98949 5.80557 7.43009 6.23305Z",
    fill: "currentColor"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCalendarHeart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "calendar-heart.0dd7d06bd23ef93acf36d1b3c7313a8b.svg";